// GENERATED FILE - DO NOT MODIFY
export enum ReceiptOfGoodsSortOrder {
    DateAscending = 1,
    DateDescending = 2,
}

export let nameof = "ReceiptOfGoodsSortOrder";
